<template>
  <div v-if="getMemorial">
    <b-container class="invitation-bar">
      <b-row align-v="center">
        <b-col class="invitation-text d-none d-md-flex" md="6" sm="12">
          {{ $t('component.invitation.text', { first_name: getMemorial().first_name, last_name: getMemorial().last_name }) }}
        </b-col>
        <b-col md="4" cols="8">
          <b-btn block @click="openModal('invite-family')">{{ $t('component.invitation.action') }}</b-btn>
        </b-col>
        <social-sharing
          :title="$t('component.invitation.title')"
          :quote="$t('component.invitation.title')"
          :url="getShareLink()"
          inline-template
        >
          <b-col md="2" cols="4">
            <b-row align-v="center">
              <b-col class="share d-flex justify-content-around">
                <network network="facebook">
                  <icon name="facebook" scale="2" />
                </network>
                <network network="twitter">
                  <icon name="twitter" scale="2" />
                </network>
              </b-col>
            </b-row>
          </b-col>
        </social-sharing>
      </b-row>
    </b-container>
    <e-modal
      event-id="invite-family"
      class="invite-family-modal"
    >
      <template v-if="emailTable.length">
        <strong>{{ $t('component.invitation.emails') }} :</strong>
        <b-list-group>
          <b-list-group-item
            v-for="email in emailTable"
            :key="email"
            class="d-flex justify-content-between align-items-center"
          >
            {{ email }}
            <b-btn variant="danger" size="sm" @click="deleteEmail(email)"><i class="ti ti-trash" /></b-btn>
          </b-list-group-item>
        </b-list-group>
        <hr>
      </template>
      <b-form @submit.prevent="onSubmit">
        <b-form-group :label="$t('form.email')" label-for="emailInput">
          <b-input-group>
            <b-form-input
              id="emailInput"
              v-model="email"
              type="email"
            />
            <b-input-group-append>
              <b-btn variant="success" @click="addEmail"><i class="ti ti-lg ti-plus-circle" /></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-button
          :disabled="!notEmptyEmails"
          type="submit"
          variant="primary"
          block
        >
          {{ $t('actions.send') }}
        </b-button>
      </b-form>
    </e-modal>
  </div>
</template>

<script>
  import EModal from '@/components/EModal';
  import SocialSharing from 'vue-social-sharing';

  export default {
    name: 'InvitationModuleComponent',
    components: {
      EModal,
      SocialSharing,
    },
    data() {
      return {
        email: '',
        emailTable: [],
        // eslint-disable-next-line no-underscore-dangle
        uid: this._uid,
      };
    },
    computed: {
      notEmptyEmails() {
        return this.email || (this.emailTable && this.emailTable.length > 0);
      },
    },
    methods: {
      getMemorial() {
        return (this.oauth() && this.user().memorial) ? this.user().memorial : this.get().memorial || {};
      },
      modalName(action) {
        return `presciber-${action}-${this.uid}`;
      },
      openModal(id, data = null) {
        this.$bus.$emit(`t-event.t-modal.${id}.open`, data);
      },
      onSubmit() {
        this.addEmail();
        const identifier = this.getMemorial().id;
        this.$ajax.post(`api/public/memorial/${identifier}/invite`, { emails: this.emailTable }, { headers: { 'Content-Language': this.$translation.getLocale() } }).then(() => {
          this.$bus.$emit('t-event.invite-memo.success');
          this.$notify({
            title: this.$t('flashes.invitation.email.title'),
            text: this.$t('flashes.invitation.email.success'),
            type: 'success',
          });
          this.$set(this, 'emailTable', []);
        }).catch(() => {
          this.$notify({
            title: this.$t('flashes.invitation.email.title'),
            text: this.$t('flashes.invitation.email.error'),
            type: 'error',
          });
        });
        this.$bus.$emit('t-event.t-modal.invite-family.close');
      },
      deleteEmail(email) {
        const index = this.emailTable.indexOf(email);
        if (index > -1) {
          this.emailTable.splice(index, 1);
        }
      },
      addEmail() {
        if (this.email) {
          this.emailTable.push(this.email);
          this.$set(this, 'email', '');
        }
      },
      getShareLink() {
        const { href } = this.$router.resolve({ name: 'memorial.show', params: { id: this.getMemorial().unique_key } });
        return `${window.location.protocol}//${window.location.host}${window.decodeURIComponent(href)}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  .invitation-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 200;
    color: $white;

    &.container {
      background-color: $primary;
      padding: 1rem;
    }

    .btn {
      background-color: darken($primary, 10);
      border: 0;
      padding: 10px;

      &:hover,
      &:focus {
        box-shadow: none;
        border: 0;
        background-color: darken($primary, 20);
      }
    }

    /deep/ .share {
      span {
        padding: 0 .5rem;

        &:hover {
          cursor: pointer;
        }
      }
    }

    @include editable-max-width(768px) {
      &.container {
        padding: 0.75rem 1rem;
      }

      .invitation-text {
        text-align: center;
        margin-bottom: 15px;
        font-size: 0.9rem;
        line-height: 1.4;
      }

      div {
        button {
          line-height: 1;
        }
      }

      .share {
        span {
          line-height: 1;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/InvitationModule.vue